import { isReddit } from '@aleph/shared-components';
import { User } from 'wb-reddit/app/routes/teams/utils';
import { TeamUser } from 'wb-reddit/app/routes/teams/container';
import { UserGroupRole, UserAccountLevel } from 'wb-reddit/graphql/generated';
import { useMemo } from 'react';

interface IProps {
	users?: TeamUser[]
	userGroupAccess: any
	selectedOwner: User
}

const REDDIT_ALLOWED_ACCOUNT_LEVELS = [UserAccountLevel.Agency, UserAccountLevel.Advertiser, UserAccountLevel.Admin];

function useOwnerOptions({ users, userGroupAccess, selectedOwner }: IProps) {
	const options = useMemo(() => {
		if (isReddit()) {
			return (users ?? [])
				.filter(
					user => (
						(user.userGroupUserRole === UserGroupRole.Admin || user.userGroupUserRole === UserGroupRole.Owner)
                        && (user.user.id !== selectedOwner.id)
                        && REDDIT_ALLOWED_ACCOUNT_LEVELS.includes(user.user?.userAccountLevel)
					),
				).map(user => user.user) ?? [];
		}

		// @ts-ignore TODO
		return (userGroupAccess ?? [])
			.filter(
				group => group.user.id !== selectedOwner.id,
			)
			.map(group => group.user) ?? [];
	}, [users, userGroupAccess, selectedOwner]);

	return options;
}

export default useOwnerOptions;
